import type { FC, RefCallback } from 'react';
import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import { Card } from '@interstate/components/Card';
import type { IDetailedAuditLog, AuditLogDealInformation } from '@makemydeal/dr-platform-types';
import { dateUtils } from '@makemydeal/dr-common-utils';
import InformationSection from './DealInformationSection';
import { DealInformationColumnDefs } from '../../types/AuditLog';

const VersionCard: FC<{
    versionData: AuditLogDealInformation[];
    changeLogData: IDetailedAuditLog[];
    lastItemRef: RefCallback<HTMLElement>;
}> = ({ versionData, lastItemRef }) => {
    const verionLength = versionData.length;
    return (
        <Box>
            {verionLength === 0 ? (
                <Card
                    data-testid="no-version-card"
                    sx={{
                        marginBottom: '1rem',
                        border: 'none',
                        padding: '1rem',
                        textAlign: 'center'
                    }}
                    content={<Typography variant="body-md">No Deal Version Found</Typography>}
                />
            ) : (
                versionData.map((versionItem: AuditLogDealInformation, index: number) => (
                    <Card
                        key={index}
                        ref={index === verionLength - 1 ? lastItemRef : undefined}
                        sx={{
                            marginBottom: '1rem',
                            border: 'none'
                        }}
                        content={
                            <>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Box>
                                        <Typography variant="body-md">Version No.</Typography>
                                        <Typography variant="body-md">{'--'}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body-md">Date/Time</Typography>
                                        <Typography variant="body-md">
                                            {dateUtils.formatDateTime(new Date(versionItem.createdOn || ''))}
                                            {dateUtils.formatAsTime(new Date(versionItem.createdOn || ''))}
                                        </Typography>
                                    </Box>
                                </Box>
                                <InformationSection data={versionItem} columnDefs={DealInformationColumnDefs} />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Box>
                                        <Typography variant="body-md">Source:</Typography>
                                        <Typography variant="body-md">{versionItem.applicationName}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="body-md">Modified By</Typography>
                                        <Typography variant="body-md">{versionItem.offerSource}</Typography>
                                    </Box>
                                </Box>
                            </>
                        }
                    />
                ))
            )}
        </Box>
    );
};

export default VersionCard;
